/**
 * Matter labels arrive from /home/flow/ pipe-delimited, e.g.
 * "Harry Figueroa III | 9203 | VA Agency". Rendered raw they read as
 * machine output ("visual quality bar" pass, 8/31). Show the client and
 * file number ("Harry Figueroa III · 9203") and keep the full string
 * for a tooltip so nothing is lost.
 */
export const splitMatterLabel = (raw) => {
  const full = String(raw || "").trim();
  if (!full) return { short: "", full: "" };
  const parts = full
    .split("|")
    .map((part) => part.trim())
    .filter(Boolean);
  return { short: parts.slice(0, 2).join(" · ") || full, full };
};
